import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

//
//
//
//
//
//
//
//
//
//
var SquareImage = function SquareImage() {
  return import('~/components/atoms/Product/SquareImage.vue');
};

export default {
  name: 'ZoomableImage',
  components: {
    SquareImage: SquareImage
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      enablePanzoom: true,
      delayClick: 400,
      tapFirst: false
    };
  },
  mounted: function mounted() {
    this.initPanzoom();
  },
  methods: {
    initPanzoom: function initPanzoom() {
      var _this = this;

      if (process.client && this.enablePanzoom) {
        // Fix bug scroll iPhone iOS 13 and lower
        var isDeviceAndiOsAvailable = /(iPhone) OS [13]+_\d(_\d)?/gi.test(navigator.userAgent);
        var touchAction = isDeviceAndiOsAvailable ? 'pan-y' : '';
        /* eslint-disable global-require */

        var Panzoom = require('@panzoom/panzoom');
        /* eslint-enable global-require */


        var panzoomElement = Panzoom(this.$refs.pinchReference, {
          minScale: 1,
          maxScale: 3,
          contain: 'outside',
          startScale: 1,
          zoom: 3,
          step: 1
        });
        panzoomElement.setStyle('touchAction', touchAction);
        this.$refs.pinchReference.addEventListener('touchstart', function (event) {
          if (!_this.tapFirst) {
            _this.tapFirst = true;
            _this.tapTimeout = setTimeout(function () {
              _this.tapFirst = false;
            }, _this.delayClick);
          } else {
            if (_this.getScale() >= 3) {
              panzoomElement.reset();
              panzoomElement.setStyle('touchAction', touchAction);
            } else if (_this.getScale() >= 2) {
              panzoomElement.zoom(3, {
                animate: true
              });
            } else {
              panzoomElement.zoom(2, {
                animate: true
              });
              panzoomElement.setStyle('touchAction', '');
            }

            _this.tapFirst = false;
            _this.tapTimeout = clearTimeout(_this.tapTimeout);
            event.preventDefault();
            event.stopPropagation();
          }

          if (_this.isZoomed() || _this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchmove', function (event) {
          if (_this.isZoomed() || _this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchend', function (event) {
          if (_this.isZoomed()) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchleave', function (event) {
          if (_this.isZoomed() || _this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        this.$refs.pinchReference.addEventListener('touchcancel', function (event) {
          if (_this.isZoomed() || _this.isPinched(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      }
    },
    isZoomed: function isZoomed() {
      return this.getScale() > 1;
    },
    isPinched: function isPinched(eventScope) {
      return eventScope.targetTouches.length === 2;
    },
    regexScale: function regexScale(scale) {
      var regex = /(\w+)\(([^)]*)\)/g;
      return regex.exec(scale);
    },
    getScale: function getScale() {
      var style = this.$refs.pinchReference.style;

      var _this$regexScale = this.regexScale(style.transform),
          _this$regexScale2 = _slicedToArray(_this$regexScale, 3),
          scaleValue = _this$regexScale2[2];

      return parseFloat(scaleValue, 10);
    }
  }
};